// AUTO-GENERATED by scripts/gen-mdi-icons.mjs — do not edit by hand.
// Tree-shaken subset of @mdi/js replacing the full @mdi/font webfont
// (ticket T00HNMV7BCIH). Re-run: node scripts/gen-mdi-icons.mjs
import {
    mdiAccountArrowLeft,
    mdiAccountBox,
    mdiAccountCancelOutline,
    mdiAccountCircle,
    mdiAccountEditOutline,
    mdiAccountGroup,
    mdiAccountSearchOutline,
    mdiAccountSwitch,
    mdiAlert,
    mdiAlertCircle,
    mdiAlertCircleOutline,
    mdiAlertOutline,
    mdiAmpersand,
    mdiAndroid,
    mdiApple,
    mdiAppleKeyboardCommand,
    mdiAppleKeyboardControl,
    mdiAppleKeyboardOption,
    mdiAppleKeyboardShift,
    mdiApplicationOutline,
    mdiArrowDown,
    mdiArrowExpand,
    mdiArrowLeft,
    mdiArrowRight,
    mdiArrowRightCircle,
    mdiArrowUp,
    mdiBackspace,
    mdiBallot,
    mdiBell,
    mdiBookOpenVariant,
    mdiBookmark,
    mdiBriefcaseAccount,
    mdiBugOutline,
    mdiBullhornOutline,
    mdiCached,
    mdiCalendar,
    mdiCalendarClockOutline,
    mdiCalendarRefreshOutline,
    mdiCardAccountDetailsOutline,
    mdiCartOutline,
    mdiCellphoneArrowDown,
    mdiCellphoneLink,
    mdiChartBar,
    mdiChartLine,
    mdiChartTimelineVariant,
    mdiCheck,
    mdiCheckCircle,
    mdiCheckboxBlankOutline,
    mdiCheckboxMarked,
    mdiCheckboxMarkedOutline,
    mdiCheckboxOutline,
    mdiChefHat,
    mdiChevronDown,
    mdiChevronLeft,
    mdiChevronRight,
    mdiChevronUp,
    mdiCircle,
    mdiCircleSmall,
    mdiClipboardArrowUpOutline,
    mdiClipboardTextOutline,
    mdiClock,
    mdiClockAlertOutline,
    mdiClockEnd,
    mdiClockOutline,
    mdiClose,
    mdiCloseCircle,
    mdiCloseCircleOutline,
    mdiCloudUpload,
    mdiCogOutline,
    mdiComment,
    mdiContentCopy,
    mdiDelete,
    mdiDetails,
    mdiDotsVertical,
    mdiDownload,
    mdiDownloadOutline,
    mdiDrag,
    mdiEarth,
    mdiEmail,
    mdiEmailFastOutline,
    mdiEye,
    mdiEyeOff,
    mdiEyedropper,
    mdiFacebook,
    mdiFileCompare,
    mdiFileEyeOutline,
    mdiFileFindOutline,
    mdiFileImage,
    mdiFileMultiple,
    mdiFileMultipleOutline,
    mdiFilePdfBox,
    mdiFileReplaceOutline,
    mdiFileSign,
    mdiFilterVariant,
    mdiFitToPage,
    mdiFlagOutline,
    mdiFormTextbox,
    mdiFormatAlignCenter,
    mdiFormatAlignLeft,
    mdiFormatAlignRight,
    mdiFormatBold,
    mdiFormatColorText,
    mdiFormatHeader1,
    mdiFormatHeader2,
    mdiFormatHeader3,
    mdiFormatHeader4,
    mdiFormatHeader5,
    mdiFormatHeader6,
    mdiFormatItalic,
    mdiFormatListBulleted,
    mdiFormatListNumbered,
    mdiFormatListText,
    mdiFormatParagraph,
    mdiFormatText,
    mdiFormatUnderline,
    mdiFullscreen,
    mdiFullscreenExit,
    mdiGithub,
    mdiGooglePlay,
    mdiHarddisk,
    mdiHead,
    mdiHeadset,
    mdiHeart,
    mdiHeartOutline,
    mdiHelpCircleOutline,
    mdiImage,
    mdiImageAutoAdjust,
    mdiImageMultipleOutline,
    mdiInformation,
    mdiInformationOutline,
    mdiInstagram,
    mdiKeyVariant,
    mdiKeyboardReturn,
    mdiKeyboardSpace,
    mdiLabel,
    mdiLink,
    mdiLinkOff,
    mdiLinkVariant,
    mdiLinkedin,
    mdiLockAlertOutline,
    mdiLockOutline,
    mdiLogout,
    mdiMagnify,
    mdiMagnifyMinus,
    mdiMagnifyMinusOutline,
    mdiMagnifyPlus,
    mdiMagnifyPlusOutline,
    mdiMastodon,
    mdiMenu,
    mdiMenuDown,
    mdiMenuOpen,
    mdiMenuRight,
    mdiMessageReplyTextOutline,
    mdiMessageTextOutline,
    mdiMicrophone,
    mdiMicrophoneOff,
    mdiMinus,
    mdiMinusBox,
    mdiMinusCircleOutline,
    mdiMonitorOff,
    mdiMonitorShare,
    mdiMovieOpenOutline,
    mdiMusicBoxOutline,
    mdiNetworkStrength2,
    mdiNetworkStrength4,
    mdiNetworkStrengthOutline,
    mdiNotebook,
    mdiNull,
    mdiOpenInNew,
    mdiOrderBoolAscendingVariant,
    mdiPageFirst,
    mdiPageLast,
    mdiPalette,
    mdiPaletteOutline,
    mdiPaperclip,
    mdiPause,
    mdiPencil,
    mdiPencilOutline,
    mdiPhoneHangup,
    mdiPictureInPictureBottomRight,
    mdiPinterest,
    mdiPlay,
    mdiPlayOutline,
    mdiPlaylistMusicOutline,
    mdiPlus,
    mdiPlusCircleOutline,
    mdiPrinter,
    mdiProgressCheck,
    mdiRadioboxBlank,
    mdiRadioboxMarked,
    mdiRecord,
    mdiRecordRec,
    mdiRecycleVariant,
    mdiRocket,
    mdiRocketLaunchOutline,
    mdiScript,
    mdiSelect,
    mdiSelection,
    mdiSend,
    mdiSignalCellular1,
    mdiSignalCellular2,
    mdiSignalCellular3,
    mdiSnapchat,
    mdiSpotify,
    mdiStar,
    mdiStarCheckOutline,
    mdiStarHalfFull,
    mdiStarOutline,
    mdiStop,
    mdiStopCircleOutline,
    mdiSubdirectoryArrowRight,
    mdiSvg,
    mdiSwapVertical,
    mdiTable,
    mdiText,
    mdiTrophy,
    mdiTuneVariant,
    mdiTwitch,
    mdiTwitter,
    mdiUnfoldMoreHorizontal,
    mdiUpdate,
    mdiUpload,
    mdiVideo,
    mdiVideoBox,
    mdiVideoOff,
    mdiViewDashboard,
    mdiViewDashboardOutline,
    mdiViewGridOutline,
    mdiVimeo,
    mdiVolumeHigh,
    mdiVolumeLow,
    mdiVolumeMedium,
    mdiVolumeVariantOff,
    mdiWeb,
    mdiWhatsapp,
    mdiWindowMinimize,
    mdiWrenchOutline,
    mdiXml,
    mdiYoutube,
} from '@mdi/js';

/** Maps `mdi-*` icon names (as used across the app + Vuetify internals) to SVG paths. */
export const mdiIconMap: Record<string, string> = {
    'mdi-account-arrow-left': mdiAccountArrowLeft,
    'mdi-account-box': mdiAccountBox,
    'mdi-account-cancel-outline': mdiAccountCancelOutline,
    'mdi-account-circle': mdiAccountCircle,
    'mdi-account-edit-outline': mdiAccountEditOutline,
    'mdi-account-group': mdiAccountGroup,
    'mdi-account-search-outline': mdiAccountSearchOutline,
    'mdi-account-switch': mdiAccountSwitch,
    'mdi-alert': mdiAlert,
    'mdi-alert-circle': mdiAlertCircle,
    'mdi-alert-circle-outline': mdiAlertCircleOutline,
    'mdi-alert-outline': mdiAlertOutline,
    'mdi-ampersand': mdiAmpersand,
    'mdi-android': mdiAndroid,
    'mdi-apple': mdiApple,
    'mdi-apple-keyboard-command': mdiAppleKeyboardCommand,
    'mdi-apple-keyboard-control': mdiAppleKeyboardControl,
    'mdi-apple-keyboard-option': mdiAppleKeyboardOption,
    'mdi-apple-keyboard-shift': mdiAppleKeyboardShift,
    'mdi-application-outline': mdiApplicationOutline,
    'mdi-arrow-down': mdiArrowDown,
    'mdi-arrow-expand': mdiArrowExpand,
    'mdi-arrow-left': mdiArrowLeft,
    'mdi-arrow-right': mdiArrowRight,
    'mdi-arrow-right-circle': mdiArrowRightCircle,
    'mdi-arrow-up': mdiArrowUp,
    'mdi-backspace': mdiBackspace,
    'mdi-ballot': mdiBallot,
    'mdi-bell': mdiBell,
    'mdi-book-open-variant': mdiBookOpenVariant,
    'mdi-bookmark': mdiBookmark,
    'mdi-briefcase-account': mdiBriefcaseAccount,
    'mdi-bug-outline': mdiBugOutline,
    'mdi-bullhorn-outline': mdiBullhornOutline,
    'mdi-cached': mdiCached,
    'mdi-calendar': mdiCalendar,
    'mdi-calendar-clock-outline': mdiCalendarClockOutline,
    'mdi-calendar-refresh-outline': mdiCalendarRefreshOutline,
    'mdi-card-account-details-outline': mdiCardAccountDetailsOutline,
    'mdi-cart-outline': mdiCartOutline,
    'mdi-cellphone-arrow-down': mdiCellphoneArrowDown,
    'mdi-cellphone-link': mdiCellphoneLink,
    'mdi-chart-bar': mdiChartBar,
    'mdi-chart-line': mdiChartLine,
    'mdi-chart-timeline-variant': mdiChartTimelineVariant,
    'mdi-check': mdiCheck,
    'mdi-check-circle': mdiCheckCircle,
    'mdi-checkbox-blank-outline': mdiCheckboxBlankOutline,
    'mdi-checkbox-marked': mdiCheckboxMarked,
    'mdi-checkbox-marked-outline': mdiCheckboxMarkedOutline,
    'mdi-checkbox-outline': mdiCheckboxOutline,
    'mdi-chef-hat': mdiChefHat,
    'mdi-chevron-down': mdiChevronDown,
    'mdi-chevron-left': mdiChevronLeft,
    'mdi-chevron-right': mdiChevronRight,
    'mdi-chevron-up': mdiChevronUp,
    'mdi-circle': mdiCircle,
    'mdi-circle-small': mdiCircleSmall,
    'mdi-clipboard-arrow-up-outline': mdiClipboardArrowUpOutline,
    'mdi-clipboard-text-outline': mdiClipboardTextOutline,
    'mdi-clock': mdiClock,
    'mdi-clock-alert-outline': mdiClockAlertOutline,
    'mdi-clock-end': mdiClockEnd,
    'mdi-clock-outline': mdiClockOutline,
    'mdi-close': mdiClose,
    'mdi-close-circle': mdiCloseCircle,
    'mdi-close-circle-outline': mdiCloseCircleOutline,
    'mdi-cloud-upload': mdiCloudUpload,
    'mdi-cog-outline': mdiCogOutline,
    'mdi-comment': mdiComment,
    'mdi-content-copy': mdiContentCopy,
    'mdi-delete': mdiDelete,
    'mdi-details': mdiDetails,
    'mdi-dots-vertical': mdiDotsVertical,
    'mdi-download': mdiDownload,
    'mdi-download-outline': mdiDownloadOutline,
    'mdi-drag': mdiDrag,
    'mdi-earth': mdiEarth,
    'mdi-email': mdiEmail,
    'mdi-email-fast-outline': mdiEmailFastOutline,
    'mdi-eye': mdiEye,
    'mdi-eye-off': mdiEyeOff,
    'mdi-eyedropper': mdiEyedropper,
    'mdi-facebook': mdiFacebook,
    'mdi-file-compare': mdiFileCompare,
    'mdi-file-eye-outline': mdiFileEyeOutline,
    'mdi-file-find-outline': mdiFileFindOutline,
    'mdi-file-image': mdiFileImage,
    'mdi-file-multiple': mdiFileMultiple,
    'mdi-file-multiple-outline': mdiFileMultipleOutline,
    'mdi-file-pdf-box': mdiFilePdfBox,
    'mdi-file-replace-outline': mdiFileReplaceOutline,
    'mdi-file-sign': mdiFileSign,
    'mdi-filter-variant': mdiFilterVariant,
    'mdi-fit-to-page': mdiFitToPage,
    'mdi-flag-outline': mdiFlagOutline,
    'mdi-form-textbox': mdiFormTextbox,
    'mdi-format-align-center': mdiFormatAlignCenter,
    'mdi-format-align-left': mdiFormatAlignLeft,
    'mdi-format-align-right': mdiFormatAlignRight,
    'mdi-format-bold': mdiFormatBold,
    'mdi-format-color-text': mdiFormatColorText,
    'mdi-format-header-1': mdiFormatHeader1,
    'mdi-format-header-2': mdiFormatHeader2,
    'mdi-format-header-3': mdiFormatHeader3,
    'mdi-format-header-4': mdiFormatHeader4,
    'mdi-format-header-5': mdiFormatHeader5,
    'mdi-format-header-6': mdiFormatHeader6,
    'mdi-format-italic': mdiFormatItalic,
    'mdi-format-list-bulleted': mdiFormatListBulleted,
    'mdi-format-list-numbered': mdiFormatListNumbered,
    'mdi-format-list-text': mdiFormatListText,
    'mdi-format-paragraph': mdiFormatParagraph,
    'mdi-format-text': mdiFormatText,
    'mdi-format-underline': mdiFormatUnderline,
    'mdi-fullscreen': mdiFullscreen,
    'mdi-fullscreen-exit': mdiFullscreenExit,
    'mdi-github': mdiGithub,
    'mdi-google-play': mdiGooglePlay,
    'mdi-harddisk': mdiHarddisk,
    'mdi-head': mdiHead,
    'mdi-headset': mdiHeadset,
    'mdi-heart': mdiHeart,
    'mdi-heart-outline': mdiHeartOutline,
    'mdi-help-circle-outline': mdiHelpCircleOutline,
    'mdi-image': mdiImage,
    'mdi-image-auto-adjust': mdiImageAutoAdjust,
    'mdi-image-multiple-outline': mdiImageMultipleOutline,
    'mdi-information': mdiInformation,
    'mdi-information-outline': mdiInformationOutline,
    'mdi-instagram': mdiInstagram,
    'mdi-key-variant': mdiKeyVariant,
    'mdi-keyboard-return': mdiKeyboardReturn,
    'mdi-keyboard-space': mdiKeyboardSpace,
    'mdi-label': mdiLabel,
    'mdi-link': mdiLink,
    'mdi-link-off': mdiLinkOff,
    'mdi-link-variant': mdiLinkVariant,
    'mdi-linkedin': mdiLinkedin,
    'mdi-lock-alert-outline': mdiLockAlertOutline,
    'mdi-lock-outline': mdiLockOutline,
    'mdi-logout': mdiLogout,
    'mdi-magnify': mdiMagnify,
    'mdi-magnify-minus': mdiMagnifyMinus,
    'mdi-magnify-minus-outline': mdiMagnifyMinusOutline,
    'mdi-magnify-plus': mdiMagnifyPlus,
    'mdi-magnify-plus-outline': mdiMagnifyPlusOutline,
    'mdi-mastodon': mdiMastodon,
    'mdi-menu': mdiMenu,
    'mdi-menu-down': mdiMenuDown,
    'mdi-menu-open': mdiMenuOpen,
    'mdi-menu-right': mdiMenuRight,
    'mdi-message-reply-text-outline': mdiMessageReplyTextOutline,
    'mdi-message-text-outline': mdiMessageTextOutline,
    'mdi-microphone': mdiMicrophone,
    'mdi-microphone-off': mdiMicrophoneOff,
    'mdi-minus': mdiMinus,
    'mdi-minus-box': mdiMinusBox,
    'mdi-minus-circle-outline': mdiMinusCircleOutline,
    'mdi-monitor-off': mdiMonitorOff,
    'mdi-monitor-share': mdiMonitorShare,
    'mdi-movie-open-outline': mdiMovieOpenOutline,
    'mdi-music-box-outline': mdiMusicBoxOutline,
    'mdi-network-strength-2': mdiNetworkStrength2,
    'mdi-network-strength-4': mdiNetworkStrength4,
    'mdi-network-strength-outline': mdiNetworkStrengthOutline,
    'mdi-notebook': mdiNotebook,
    'mdi-null': mdiNull,
    'mdi-open-in-new': mdiOpenInNew,
    'mdi-order-bool-ascending-variant': mdiOrderBoolAscendingVariant,
    'mdi-page-first': mdiPageFirst,
    'mdi-page-last': mdiPageLast,
    'mdi-palette': mdiPalette,
    'mdi-palette-outline': mdiPaletteOutline,
    'mdi-paperclip': mdiPaperclip,
    'mdi-pause': mdiPause,
    'mdi-pencil': mdiPencil,
    'mdi-pencil-outline': mdiPencilOutline,
    'mdi-phone-hangup': mdiPhoneHangup,
    'mdi-picture-in-picture-bottom-right': mdiPictureInPictureBottomRight,
    'mdi-pinterest': mdiPinterest,
    'mdi-play': mdiPlay,
    'mdi-play-outline': mdiPlayOutline,
    'mdi-playlist-music-outline': mdiPlaylistMusicOutline,
    'mdi-plus': mdiPlus,
    'mdi-plus-circle-outline': mdiPlusCircleOutline,
    'mdi-printer': mdiPrinter,
    'mdi-progress-check': mdiProgressCheck,
    'mdi-radiobox-blank': mdiRadioboxBlank,
    'mdi-radiobox-marked': mdiRadioboxMarked,
    'mdi-record': mdiRecord,
    'mdi-record-rec': mdiRecordRec,
    'mdi-recycle-variant': mdiRecycleVariant,
    'mdi-rocket': mdiRocket,
    'mdi-rocket-launch-outline': mdiRocketLaunchOutline,
    'mdi-script': mdiScript,
    'mdi-select': mdiSelect,
    'mdi-selection': mdiSelection,
    'mdi-send': mdiSend,
    'mdi-signal-cellular-1': mdiSignalCellular1,
    'mdi-signal-cellular-2': mdiSignalCellular2,
    'mdi-signal-cellular-3': mdiSignalCellular3,
    'mdi-snapchat': mdiSnapchat,
    'mdi-spotify': mdiSpotify,
    'mdi-star': mdiStar,
    'mdi-star-check-outline': mdiStarCheckOutline,
    'mdi-star-half-full': mdiStarHalfFull,
    'mdi-star-outline': mdiStarOutline,
    'mdi-stop': mdiStop,
    'mdi-stop-circle-outline': mdiStopCircleOutline,
    'mdi-subdirectory-arrow-right': mdiSubdirectoryArrowRight,
    'mdi-svg': mdiSvg,
    'mdi-swap-vertical': mdiSwapVertical,
    'mdi-table': mdiTable,
    'mdi-text': mdiText,
    'mdi-trophy': mdiTrophy,
    'mdi-tune-variant': mdiTuneVariant,
    'mdi-twitch': mdiTwitch,
    'mdi-twitter': mdiTwitter,
    'mdi-unfold-more-horizontal': mdiUnfoldMoreHorizontal,
    'mdi-update': mdiUpdate,
    'mdi-upload': mdiUpload,
    'mdi-video': mdiVideo,
    'mdi-video-box': mdiVideoBox,
    'mdi-video-off': mdiVideoOff,
    'mdi-view-dashboard': mdiViewDashboard,
    'mdi-view-dashboard-outline': mdiViewDashboardOutline,
    'mdi-view-grid-outline': mdiViewGridOutline,
    'mdi-vimeo': mdiVimeo,
    'mdi-volume-high': mdiVolumeHigh,
    'mdi-volume-low': mdiVolumeLow,
    'mdi-volume-medium': mdiVolumeMedium,
    'mdi-volume-variant-off': mdiVolumeVariantOff,
    'mdi-web': mdiWeb,
    'mdi-whatsapp': mdiWhatsapp,
    'mdi-window-minimize': mdiWindowMinimize,
    'mdi-wrench-outline': mdiWrenchOutline,
    'mdi-xml': mdiXml,
    'mdi-youtube': mdiYoutube,
};
